import apiService from './apiService'

export const getFaq = (product_id) => {
  return apiService.get(URIS_D('getFaq',product_id))
}

export const createFaq = (payload) => {
  return apiService.post(URIS.newFaq, payload)
}

export const updateFaq = (product_id, payload) => {
  return apiService.patch(URIS_D('updateFaq',product_id), payload);
}

export const removeFaq = (productId, faqId) => {
  return apiService.delete(URIS_D('removeFaq',productId, faqId));
}

export const addFaq = (product_id, payload) => {
  return apiService.patch(URIS_D('addFaq',product_id), payload);
}

const URIS_D = (url, param1 = '', param2 = '') => {
  return {
    getFaq: `http://localhost:4000/faq/${param1}`,
    updateFaq : `http://localhost:4000/faq/update/${param1}`,
    addFaq: `http://localhost:4000/faq/create/${param1}`,
    removeFaq: `http://localhost:4000/faq/product/${param1}/faq/${param2}`,
  }[url]
}

const URIS = {
  newFaq: 'http://localhost:4000/faq/create',
}
